import { render, staticRenderFns } from "./ReadyArticlesPage.vue?vue&type=template&id=3e4ba674&scoped=true&"
import script from "./ReadyArticlesPage.vue?vue&type=script&lang=js&"
export * from "./ReadyArticlesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ba674",
  null
  
)

export default component.exports